var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      on: { hidden: _vm.resetForm, shown: _vm.loadForm },
      model: {
        value: _vm.localValue,
        callback: function($$v) {
          _vm.localValue = $$v
        },
        expression: "localValue"
      }
    },
    [
      _c("h3", {
        staticClass: "text-center mb-4",
        domProps: { innerHTML: _vm._s(_vm.$t("healthMonitoring")) }
      }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c("b-col", { attrs: { cols: "12", md: "4" } }, [
            _c("h5", {
              domProps: { textContent: _vm._s(_vm.$t("reminderFrequency")) }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "2" } },
                    [
                      _c("base-input", {
                        attrs: {
                          type: "number",
                          min: 1,
                          max: 24,
                          placeholder: _vm.$t("frequency")
                        },
                        model: {
                          value: _vm.data.interval,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "interval", $$v)
                          },
                          expression: "data.interval"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c("base-select", {
                        attrs: {
                          loading: false,
                          options: _vm.reminderIntervalSource,
                          label: "name",
                          valueProp: "value",
                          placeholder: _vm.$t("reminderMedicationForm.option")
                        },
                        model: {
                          value: _vm.data.intervalPeriod,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "intervalPeriod", $$v)
                          },
                          expression: "data.intervalPeriod"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("h5", {
              staticClass: "mt-3",
              domProps: {
                textContent: _vm._s(_vm.$t("reminderMedicationForm.endDate"))
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", md: "3" } },
            [
              _c("base-datepicker", {
                attrs: { dateAfterNow: "" },
                model: {
                  value: _vm.data.endDate,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "endDate", $$v)
                  },
                  expression: "data.endDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.created
        ? _c(
            "div",
            { staticClass: "text-center mb-4" },
            [
              _c(
                "base-button",
                { attrs: { red: "" }, on: { click: _vm.removeReminder } },
                [_vm._v(_vm._s(_vm.$t("removeReminder")))]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("base-button", { on: { click: _vm.save } }, [
            _vm._v(_vm._s(_vm.$t("save")))
          ]),
          _vm._v(" "),
          _c(
            "base-button",
            { attrs: { gray: "" }, on: { click: _vm.resetForm } },
            [_vm._v(_vm._s(_vm.$t("cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3f6fbf0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3f6fbf0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HistoryVariableReminder.vue
// module id = 2609
// module chunks = 29 32 34 37 38 141